(function(){var sections=document.querySelectorAll(".glow-anatomy");sections.length&&sections.forEach(function(sec){if("IntersectionObserver"in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){e.isIntersecting&&(sec.classList.add("is-visible"),obs.unobserve(sec))})},{threshold:.2});obs.observe(sec)}else sec.classList.add("is-visible")})})(),(function(){var sliders=document.querySelectorAll(".glow-baSlider");sliders.forEach(function(slider){if(slider.dataset.baInit==="true")return;slider.dataset.baInit="true";var beforeImg=slider.querySelector(".glow-baSlider__before"),afterWrap=slider.querySelector(".glow-baSlider__after-wrap"),afterImg=slider.querySelector(".glow-baSlider__after"),handle=slider.querySelector(".glow-baSlider__handle"),dragging=!1;function syncAfterSize(){var rect=slider.getBoundingClientRect();afterImg.style.width=rect.width+"px",afterImg.style.height="auto"}syncAfterSize(),window.addEventListener("resize",syncAfterSize);function setPos(x){var rect=slider.getBoundingClientRect(),pct=(x-rect.left)/rect.width*100;pct=Math.max(0,Math.min(100,pct)),afterWrap.style.width=pct+"%",handle.style.left=pct+"%"}function start(e){dragging=!0,e.preventDefault()}function move(e){if(dragging){var x=e.touches?e.touches[0].clientX:e.clientX;setPos(x)}}function end(){dragging=!1}slider.addEventListener("mousedown",start),slider.addEventListener("touchstart",start,{passive:!1}),document.addEventListener("mousemove",move),document.addEventListener("touchmove",move,{passive:!1}),document.addEventListener("mouseup",end),document.addEventListener("touchend",end),slider.addEventListener("click",function(e){var x=e.touches?e.touches[0].clientX:e.clientX;setPos(x)})})})(),(function(){function glowOpenReviewD(card){var bg=document.querySelector(".glow-reviews__modal-bgD"),r=parseInt(card.dataset.rating)||5;document.getElementById("glowModalStarsD").textContent="★".repeat(r)+"☆".repeat(Math.max(0,5-r)),document.getElementById("glowModalTitleD").textContent=card.dataset.title||"",document.getElementById("glowModalBodyD").textContent=card.dataset.body||"",document.getElementById("glowModalReviewerD").textContent="— "+(card.dataset.reviewer||"Cliente");var photo=document.getElementById("glowModalPhotoD");card.dataset.photo&&card.dataset.photo.length>0?(photo.src=card.dataset.photo,photo.style.display="block"):photo.style.display="none",bg.classList.add("open"),document.body.style.overflow="hidden"}function glowCloseReviewD(){document.querySelector(".glow-reviews__modal-bgD").classList.remove("open"),document.body.style.overflow=""}function glowZoomPhotoD(img){window.open(img.src,"_blank")}document.addEventListener("keydown",function(e){e.key==="Escape"&&glowCloseReviewD()})})(),(function(){function glowOpenReview(card){var bg=document.querySelector(".glow-reviews__modal-bg"),r=parseInt(card.dataset.rating)||5;document.getElementById("glowModalStars").textContent="★".repeat(r)+"☆".repeat(Math.max(0,5-r)),document.getElementById("glowModalTitle").textContent=card.dataset.title||"",document.getElementById("glowModalBody").textContent=card.dataset.body||"",document.getElementById("glowModalReviewer").textContent="— "+(card.dataset.reviewer||"Cliente");var photo=document.getElementById("glowModalPhoto");card.dataset.photo&&card.dataset.photo.length>0?(photo.src=card.dataset.photo,photo.style.display="block"):photo.style.display="none",bg.classList.add("open"),document.body.style.overflow="hidden"}function glowCloseReview(){document.querySelector(".glow-reviews__modal-bg").classList.remove("open"),document.body.style.overflow=""}function glowZoomPhoto(img){window.open(img.src,"_blank")}document.addEventListener("keydown",function(e){e.key==="Escape"&&glowCloseReview()})})(),(function(){var atc=document.getElementById("glow-sticky-atc");if(!atc)return;var mainProductSection=document.querySelector('.product, section.product, [class*="main-product"], .section--padding')||document.body;function onScroll(){var scrollY=window.scrollY||window.pageYOffset;scrollY>600?atc.style.bottom="env(safe-area-inset-bottom, 0px)":atc.style.bottom="calc(-140px - env(safe-area-inset-bottom, 0px))"}window.addEventListener("scroll",onScroll,{passive:!0}),onScroll()})(),(function(){var bar=document.querySelector(".proof-points-bar");if(bar)if("IntersectionObserver"in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){e.isIntersecting&&(bar.classList.add("is-visible"),obs.unobserve(bar))})},{threshold:.2});obs.observe(bar)}else bar.classList.add("is-visible")})(),(function(){var sec=document.querySelector(".glow-engage");if(sec)if("IntersectionObserver"in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){e.isIntersecting&&(sec.classList.add("is-visible"),obs.unobserve(sec))})},{threshold:.15});obs.observe(sec)}else sec.classList.add("is-visible")})(),(function(){var sec=document.querySelector(".glow-why");if(sec)if("IntersectionObserver"in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){e.isIntersecting&&(sec.classList.add("is-visible"),obs.unobserve(sec))})},{threshold:.15});obs.observe(sec)}else sec.classList.add("is-visible")})(),(function(){function glowOpenReviewH(card){var bg=document.querySelector(".glow-reviews__modal-bgH"),r=parseInt(card.dataset.rating)||5;document.getElementById("glowModalStarsH").textContent="★".repeat(r)+"☆".repeat(Math.max(0,5-r)),document.getElementById("glowModalTitleH").textContent=card.dataset.title||"",document.getElementById("glowModalBodyH").textContent=card.dataset.body||"",document.getElementById("glowModalReviewerH").textContent="— "+(card.dataset.reviewer||"Cliente");var photo=document.getElementById("glowModalPhotoH");card.dataset.photo&&card.dataset.photo.length>0?(photo.src=card.dataset.photo,photo.style.display="block"):photo.style.display="none",bg.classList.add("open"),document.body.style.overflow="hidden"}function glowCloseReviewH(){document.querySelector(".glow-reviews__modal-bgH").classList.remove("open"),document.body.style.overflow=""}function glowZoomPhotoH(img){window.open(img.src,"_blank")}document.addEventListener("keydown",function(e){e.key==="Escape"&&glowCloseReviewH()})})();
(function(){var STORAGE_KEY="glow-menu-open-item",restoring=!1;function isInMenu(el){return!!(el&&el.closest&&el.closest("menu-drawer, header-menu, .header__submenu, nav"))}function restoreMenuState(){if(!restoring){restoring=!0;try{var savedLabel=null;try{savedLabel=sessionStorage.getItem(STORAGE_KEY)}catch(e){}var isProductPage=(window.location.pathname||"").indexOf("/products/")===0;document.querySelectorAll("menu-drawer details, header-menu details").forEach(function(d){if(!d.hasAttribute("open")){var summary=d.querySelector("summary");if(summary){var label=summary.textContent.trim(),containsProductLink=!!d.querySelector('a[href*="/products/"], a[href*="/collections/"]');if(savedLabel&&label===savedLabel){d.setAttribute("open","");return}isProductPage&&containsProductLink&&d.setAttribute("open","")}}})}finally{setTimeout(function(){restoring=!1},100)}}}document.addEventListener("click",function(e){var link=e.target.closest("a");if(link){var details=link.closest("details");if(details&&isInMenu(details)){var summary=details.querySelector("summary");if(summary)try{sessionStorage.setItem(STORAGE_KEY,summary.textContent.trim())}catch(e2){}}}var btn=e.target.closest('.header__icon--menu, [aria-controls*="menu-drawer"], [aria-controls*="MenuDrawer"]');btn&&setTimeout(restoreMenuState,350)},!0),document.readyState==="loading"?document.addEventListener("DOMContentLoaded",restoreMenuState):restoreMenuState()})(),(function(){var initialized=!1;function initMediaAutoplay(){if(!initialized){var videos=document.querySelectorAll('.product__media video, media-gallery video, product-media video, [class*="product__media"] video');videos.length&&(initialized=!0,videos.forEach(function(video){if(video.muted=!0,video.playsInline=!0,video.setAttribute("muted",""),video.setAttribute("playsinline",""),"IntersectionObserver"in window){var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting&&e.intersectionRatio>.4){var p=video.play();p&&p.catch&&p.catch(function(){})}else try{video.pause()}catch(e){}})},{threshold:.5});obs.observe(video)}}))}}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",initMediaAutoplay):setTimeout(initMediaAutoplay,500)})();
//# sourceMappingURL=/cdn/shop/t/17/assets/glow-custom.js.map


/* === V12 :: Summer timer countdown === */
(function() {
  function initGlowTimers() {
    document.querySelectorAll('[data-glow-timer]').forEach(function(timer) {
      if (timer.dataset.glowInit === 'true') return;
      timer.dataset.glowInit = 'true';
      var deadline = new Date(timer.dataset.deadline + '+02:00').getTime();
      var dEl = timer.querySelector('[data-days]');
      var hEl = timer.querySelector('[data-hours]');
      var mEl = timer.querySelector('[data-minutes]');
      var sEl = timer.querySelector('[data-seconds]');
      function tick() {
        var now = new Date().getTime();
        var diff = deadline - now;
        if (diff <= 0) { timer.style.display = 'none'; return; }
        var d = Math.floor(diff / (1000 * 60 * 60 * 24));
        var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var s = Math.floor((diff % (1000 * 60)) / 1000);
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initGlowTimers); } else { initGlowTimers(); }
  document.addEventListener('shopify:section:load', initGlowTimers);
})();

/* === V12 :: Autoplay for UGC videos === */
(function() {
  function initUgcAutoplay() {
    var videos = document.querySelectorAll('.glow-ugc-duo__phone video, .glow-ugc-lift__phone video, .glow-ugc-serum__phone video, .glow-ugc__phone video');
    videos.forEach(function(video) {
      if (video.dataset.glowUgcInit === '1') return;
      video.dataset.glowUgcInit = '1';
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
              var p = video.play();
              if (p && p.catch) p.catch(function(){});
            } else { try { video.pause(); } catch(e){} }
          });
        }, { threshold: [0, 0.25, 0.5] });
        obs.observe(video);
      } else { try { video.play(); } catch(e){} }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initUgcAutoplay); } else { setTimeout(initUgcAutoplay, 300); }
  setTimeout(initUgcAutoplay, 1500);
})();

/* === V12 :: Reviews carousel autoplay (glisse lente) === */
(function() {
  function initReviewsAutoplay() {
    var tracks = document.querySelectorAll('.glow-reviews__track');
    tracks.forEach(function(track) {
      return; /* v22 : défilement auto désactivé (on garde les avis photo en premier) */
      if (track.dataset.glowAutoInit === '1') return;
      track.dataset.glowAutoInit = '1';
      var paused = false;
      track.addEventListener('mouseenter', function(){ paused = true; });
      track.addEventListener('mouseleave', function(){ paused = false; });
      track.addEventListener('touchstart', function(){ paused = true; }, { passive: true });
      track.addEventListener('touchend', function(){ setTimeout(function(){ paused = false; }, 3000); }, { passive: true });
      setInterval(function() {
        if (paused) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 20) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: 260, behavior: 'smooth' });
        }
      }, 5000);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initReviewsAutoplay); } else { setTimeout(initReviewsAutoplay, 500); }
})();

/* === V13.4 :: Cart upsell add — keep drawer open === */
(function() {
  function getSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function(s){ return s.section || s.id; });
      } catch(e) {}
    }
    // Fallback to Dawn defaults
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-glow-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    btn.setAttribute('disabled', 'disabled');
    var originalLabel = btn.textContent;
    btn.textContent = 'Ajout en cours…';

    var body = {
      items: [{ id: parseInt(vid, 10), quantity: 1 }],
      sections: getSections(),
      sections_url: window.location.pathname
    };

    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err){ throw err; });
      return res.json();
    })
    .then(function(data) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else {
        // Fallback: dispatch native events so drawer + progress bar refresh
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      // Ensure drawer stays open
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active');
          drawer.setAttribute('open', '');
        }
      }
      btn.removeAttribute('disabled');
      btn.textContent = originalLabel;
    })
    .catch(function(err) {
      console.error('[glow-upsell V13.4] Add failed:', err);
      btn.removeAttribute('disabled');
      btn.textContent = originalLabel;
      alert("Impossible d'ajouter ce produit. Rafraîchis la page et réessaie.");
    });
  }, true);
})();

/* === V13.3 :: 2-tier progress bar === */
(function() {
  var pendingTimer = null;
  var boundNodes = new WeakSet();

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function applyState(el, total) {
    var tier1 = parseInt(el.getAttribute('data-tier1'), 10) || 3490;
    var tier2 = parseInt(el.getAttribute('data-tier2'), 10) || 8000;
    var pct = Math.min(100, (total / tier2) * 100);
    var fill = el.querySelector('.glow-progress__fill');
    if (fill) fill.style.width = pct + '%';

    var msg = el.querySelector('.glow-progress__message');
    if (msg) {
      if (total < tier1) {
        msg.innerHTML = 'Encore <strong>' + formatMoney(tier1 - total) + '</strong> pour ta livraison offerte 🚚';
      } else if (total < tier2) {
        msg.innerHTML = 'Livraison offerte 🎉 · Encore <strong>' + formatMoney(tier2 - total) + '</strong> pour ton tote bag 🎁';
      } else {
        msg.innerHTML = '🩷 Tu débloques tout : livraison offerte + tote bag';
      }
    }

    var m1 = el.querySelector('[data-milestone="tier1"]');
    var m2 = el.querySelector('[data-milestone="tier2"]');
    if (m1) m1.classList.toggle('glow-progress__milestone--unlocked', total >= tier1);
    if (m2) m2.classList.toggle('glow-progress__milestone--unlocked', total >= tier2);
  }

  function updateProgress() {
    var containers = document.querySelectorAll('.glow-progress');
    if (!containers.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.glow-progress').forEach(function(el) {
          applyState(el, cart.total_price);
        });
      })
      .catch(function(err) { console.error('[glow-progress]', err); });
  }

  function schedule() {
    if (pendingTimer) return;
    pendingTimer = setTimeout(function() {
      pendingTimer = null;
      updateProgress();
    }, 80);
  }

  function bindDrawer() {
    var drawers = document.querySelectorAll('#cart-drawer, [id^="CartDrawer"], cart-drawer');
    drawers.forEach(function(drawer) {
      if (boundNodes.has(drawer)) return;
      boundNodes.add(drawer);
      var obs = new MutationObserver(function(mutations) {
        // Ignore self-mutations inside .glow-progress to avoid loops when we set innerHTML
        var relevant = mutations.some(function(m) {
          var t = m.target;
          if (!t) return true;
          if (t.nodeType !== 1) t = t.parentElement;
          if (!t) return true;
          return !(t.closest && t.closest('.glow-progress'));
        });
        if (relevant) schedule();
      });
      obs.observe(drawer, { childList: true, subtree: true });
    });
  }

  function init() {
    updateProgress();
    bindDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn / theme events
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  // Rebind if the drawer is swapped in later
  document.addEventListener('cart:refresh', bindDrawer);
})();


/* === V13.5 :: Cart quantity +/− bypass Moonbundle === */
(function() {
  function getSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function(s){ return s.section || s.id; });
      } catch(e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function isInDrawer(el) {
    return !!el.closest('cart-drawer, #CartDrawer, [id^="CartDrawer"]');
  }

  function getLineInfo(btn) {
    // Dawn's quantity-input contains an <input name="updates[]" data-index="X" value="Y">
    var container = btn.closest('quantity-input, .quantity, .cart-item');
    if (!container) return null;
    var input = container.querySelector('input[name="updates[]"], input[data-index], input.quantity__input');
    if (!input) return null;
    var lineIndex = parseInt(input.getAttribute('data-index') || (input.dataset && input.dataset.index), 10);
    var currentQty = parseInt(input.value, 10);
    if (isNaN(lineIndex) || isNaN(currentQty)) return null;
    return { lineIndex: lineIndex, currentQty: currentQty };
  }

  document.addEventListener('click', function(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('button[name="plus"], button[name="minus"], button[name="Plus"], button[name="Minus"]');
    if (!btn) return;
    if (!isInDrawer(btn)) return; // only intercept the drawer, not the /cart page

    var info = getLineInfo(btn);
    if (!info) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var rawName = (btn.getAttribute('name') || btn.name || '').toLowerCase();
    var isPlus = rawName === 'plus';
    var newQty = isPlus ? info.currentQty + 1 : info.currentQty - 1;
    if (newQty < 0) newQty = 0;

    btn.setAttribute('disabled', 'disabled');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: info.lineIndex,
        quantity: newQty,
        sections: getSections(),
        sections_url: window.location.pathname
      })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err){ throw err; });
      return res.json();
    })
    .then(function(data) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents(data);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      // Keep drawer open
      if (drawer && typeof drawer.open === 'function') drawer.open();
    })
    .catch(function(err) {
      console.error('[glow-qty V13.5] change failed:', err);
    })
    .finally(function() {
      btn.removeAttribute('disabled');
    });
  }, true); // CAPTURE PHASE — fires BEFORE Moonbundle
})();


/* === V13.7 :: Network fetch interceptor — force + button to increment existing line === */
(function() {
  var originalFetch = window.fetch;

  function normalizeUrl(u) {
    if (typeof u === 'string') return u;
    if (u && typeof u.url === 'string') return u.url;
    if (u instanceof URL) return u.toString();
    return String(u || '');
  }

  function shouldIntercept(urlStr, options) {
    if (!urlStr) return false;
    if (!/\/cart\/add(\.js|\.json)?(\?|$)/.test(urlStr)) return false;
    if (!options || !options.body) return false;
    if ((options.method || 'GET').toUpperCase() !== 'POST') return false;
    return true;
  }

  function parseBody(body) {
    try {
      if (typeof body === 'string') return JSON.parse(body);
      if (body instanceof FormData) {
        var obj = {};
        body.forEach(function(v, k) { obj[k] = v; });
        return obj;
      }
      return body;
    } catch(e) { return null; }
  }

  function getDrawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { return drawer.getSectionsToRender().map(function(s){ return s.section || s.id; }); } catch(e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      drawer.renderContents(data);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  window.fetch = function(input, init) {
    var urlStr = normalizeUrl(input);
    var options = init || (typeof input === 'object' && input.method ? input : {});

    // Only intercept POST /cart/add from a click ORIGINATING in the drawer
    // Heuristic: check if the last user activity was in the drawer
    var lastClickInDrawer = window.__glowLastClickInDrawer === true;
    if (!shouldIntercept(urlStr, options) || !lastClickInDrawer) {
      return originalFetch.apply(this, arguments);
    }

    var body = parseBody(options.body);
    if (!body || !body.items || !Array.isArray(body.items) || body.items.length !== 1) {
      return originalFetch.apply(this, arguments);
    }

    var item = body.items[0];
    var variantId = parseInt(item.id, 10);
    if (!variantId) return originalFetch.apply(this, arguments);

    // Fetch current cart to see if this variant already exists as a line
    return originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Find existing line with SAME variant AND no bundle properties conflict
        var existingIdx = -1;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantId) {
            existingIdx = i;
            break;
          }
        }
        if (existingIdx === -1) {
          // No existing line — fall through to original add
          return originalFetch.apply(window, [input, init]);
        }
        // Convert to /cart/change.js increment on existing line
        var existingLine = cart.items[existingIdx];
        var newQty = existingLine.quantity + (item.quantity || 1);
        var changePayload = {
          line: existingIdx + 1, // Shopify line indices are 1-based
          quantity: newQty,
          sections: getDrawerSections(),
          sections_url: window.location.pathname
        };
        return originalFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(changePayload)
        }).then(function(res) {
          if (res.ok) {
            res.clone().json().then(refreshDrawer).catch(function(){});
          }
          return res;
        });
      })
      .catch(function() {
        return originalFetch.apply(window, [input, init]);
      });
  };

  // Track whether the last click was in the drawer — used above to gate interception
  document.addEventListener('click', function(e) {
    window.__glowLastClickInDrawer = !!e.target.closest('cart-drawer, #CartDrawer, [id^="CartDrawer"]');
    // Auto-reset after 1s so unrelated fetches later don't get intercepted
    if (window.__glowClickResetTimer) clearTimeout(window.__glowClickResetTimer);
    window.__glowClickResetTimer = setTimeout(function() { window.__glowLastClickInDrawer = false; }, 1000);
  }, true);
})();

/* === V13.8 :: Auto-merge duplicate cart lines === */
(function() {
  var mergeInFlight = false;
  var mergeCooldownUntil = 0;

  function getDrawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try { return drawer.getSectionsToRender().map(function(s){ return s.section || s.id; }); } catch(e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      drawer.renderContents(data);
    }
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function propsSignature(props) {
    if (!props) return '';
    var keys = Object.keys(props).filter(function(k) { return k[0] !== '_' || k.indexOf('_mb') === 0 || k.indexOf('_moonbundle') === 0; });
    keys.sort();
    return keys.map(function(k) { return k + '=' + props[k]; }).join('|');
  }

  function tryMerge() {
    if (mergeInFlight) return;
    if (Date.now() < mergeCooldownUntil) return;
    mergeInFlight = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var groups = {};
        cart.items.forEach(function(item, idx) {
          var key = item.variant_id + '::' + propsSignature(item.properties);
          if (!groups[key]) groups[key] = [];
          groups[key].push({ idx: idx, qty: item.quantity });
        });

        var hasDup = false;
        Object.keys(groups).forEach(function(k) { if (groups[k].length > 1) hasDup = true; });
        if (!hasDup) { mergeInFlight = false; return; }

        var updates = cart.items.map(function(item) { return item.quantity; });
        Object.keys(groups).forEach(function(k) {
          var lines = groups[k];
          if (lines.length <= 1) return;
          var total = lines.reduce(function(s, l) { return s + l.qty; }, 0);
          updates[lines[0].idx] = total;
          for (var i = 1; i < lines.length; i++) updates[lines[i].idx] = 0;
        });

        mergeCooldownUntil = Date.now() + 2000;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: getDrawerSections(),
            sections_url: window.location.pathname
          })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          refreshDrawer(data);
        });
      })
      .catch(function(err) {
        console.warn('[glow-merge V13.8] merge failed', err);
      })
      .finally(function() {
        mergeInFlight = false;
      });
  }

  document.addEventListener('cart:refresh', tryMerge);
  document.addEventListener('cart:updated', tryMerge);

  var mo = new MutationObserver(function() {
    if (window.__glowMergeTimer) clearTimeout(window.__glowMergeTimer);
    window.__glowMergeTimer = setTimeout(tryMerge, 300);
  });
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();




/* V14.3 :: Comparison table scroll fade-in */
(function () {
  if (typeof window === 'undefined') return;
  function armObserver() {
    var rows = document.querySelectorAll('[data-glow-comparison] .glow-comparison__row:not(.glow-comparison__row--head)');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (r) { r.classList.add('glow-comparison__row--visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var idx = parseInt(el.getAttribute('data-glow-comparison-idx') || '0', 10);
        setTimeout(function () {
          el.classList.add('glow-comparison__row--visible');
        }, idx * 100);
        io.unobserve(el);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    rows.forEach(function (r, i) {
      r.setAttribute('data-glow-comparison-idx', String(i));
      io.observe(r);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armObserver);
  } else {
    armObserver();
  }
})();
